import { render, staticRenderFns } from "./InvitationCode.vue?vue&type=template&id=2d130e0a&scoped=true&"
import script from "./InvitationCode.vue?vue&type=script&lang=js&"
export * from "./InvitationCode.vue?vue&type=script&lang=js&"
import style0 from "./InvitationCode.vue?vue&type=style&index=0&id=2d130e0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d130e0a",
  null
  
)

export default component.exports